/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { IS_BROWSER } from '@zcode/env'
import { getUserAgent } from '@zcode/utils'
import invariant from 'tiny-invariant'

// from https://stackoverflow.com/questions/5916900/how-can-you-detect-the-version-of-a-browser
export const getBrowserInfo = (userAgent: string) => {
  const ua = userAgent || getUserAgent()
  if (!ua) {
    return { name: undefined, version: undefined }
  }
  let M =
    ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
    []
  if (M[1] && /trident/i.test(M[1])) {
    const ieVer = /\brv[ :]+(\d+)/g.exec(ua) || []
    return { name: 'IE', version: ieVer[1] || '' }
  }
  if (M[1] === 'Chrome') {
    const operaVer = ua.match(/\bOPR|Edge\/(\d+)/)
    if (operaVer != null) {
      return { name: 'Opera', version: operaVer[1] }
    }
  }
  if (M[1] && M[2]) {
    M = [M[1], M[2]]
  } else if (IS_BROWSER && typeof window !== 'undefined' && window.navigator) {
    M = [window.navigator.appName, window.navigator.appVersion, '-?']
  } else {
    M = []
  }
  const ver = ua.match(/version\/(\d+)/i)
  if (ver != null) {
    invariant(ver[1])
    M.splice(1, 1, ver[1])
  }

  return {
    name: M[0],
    version: M[1],
  }
}
